/**************************************************
 * Nombre:       Tarjeta_Persona
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Persona = ({item}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{color: '#fff'}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <img src={item.img} width={'auto'} height={!masSM ? 150 : 200}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 3}}>
                <Typography sx={{
                    fontWeight: 600,
                    fontSize: !masSM ? 18 : 24,
                    textAlign: 'center',
                    lineHeight: 1.2
                }}>{item.nombre}</Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{fontSize: !masSM ? 16 : 18}}>{item.descripcion}</Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Persona